import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const RestaurantPushNotification = lazyWithRetry(() => import(/* webpackChunkName: "restaurant-push-notification" */'../../component/RestaurantPushNotification'))

const RestaurantPushNotificationPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<RestaurantPushNotification />
		</Suspense>
	)
})

RestaurantPushNotificationPage.displayName = 'RestaurantPushNotificationPage'
export default RestaurantPushNotificationPage
